import React, { useState } from 'react';
import { 
  FormControl, 
  FormGroup, 
  FormControlLabel, 
  Checkbox, 
  FormHelperText 
} from '@mui/material';

const BooleanFilter = ({ value, onChange, error, columnName }) => {
  // Parse the existing SQL filter value to set initial state
  const [selected, setSelected] = useState(() => {
    const initialState = {
      true: false,
      false: false,
      null: false
    };
    
    // Handle parsing the incoming SQL filter string
    if (typeof value === 'string' && value.trim()) {
      if (value.includes('IS TRUE')) initialState.true = true;
      if (value.includes('IS FALSE')) initialState.false = true;
      if (value.includes('IS NULL')) initialState.null = true;
    }
    
    return initialState;
  });

  const handleChange = (checked, valueType) => {
    const newSelected = { ...selected, [valueType]: checked };
    setSelected(newSelected);

    // Build the SQL filter string
    const conditions = [];
    if (newSelected.true) conditions.push(`${columnName} IS TRUE`);
    if (newSelected.false) conditions.push(`${columnName} IS FALSE`);
    if (newSelected.null) conditions.push(`${columnName} IS NULL`);

    if (conditions.length === 0) {
      onChange('');
    } else if (conditions.length === 1) {
      onChange(conditions[0]);
    } else {
      onChange(`(${conditions.join(' OR ')})`);
    }
  };

  return (
    <FormControl 
      component="fieldset" 
      error={error}
      sx={{ mt: 1 }}
    >
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox 
              checked={selected.true}
              onChange={(e) => handleChange(e.target.checked, 'true')}
            />
          }
          label="True"
        />
        <FormControlLabel
          control={
            <Checkbox 
              checked={selected.false}
              onChange={(e) => handleChange(e.target.checked, 'false')}
            />
          }
          label="False"
        />
        <FormControlLabel
          control={
            <Checkbox 
              checked={selected.null}
              onChange={(e) => handleChange(e.target.checked, 'null')}
            />
          }
          label="NULL"
        />
      </FormGroup>
      {error && (
        <FormHelperText>Please select at least one option</FormHelperText>
      )}
    </FormControl>
  );
};

export default BooleanFilter;
